import { render, staticRenderFns } from "./RoleAddEditStep1.vue?vue&type=template&id=dc233b72&scoped=true"
import script from "./RoleAddEditStep1.vue?vue&type=script&lang=js"
export * from "./RoleAddEditStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc233b72",
  null
  
)

export default component.exports